export enum WS_EVENT {
  PING = "WS_PING",
  PONG = "WS_PONG",
  RECONNECT = "RECONNECT",
  DISCONNECT = "DISCONNECT",
  SEND_MSG = "WS_SEND_MESSAGE",
  CALL_SIGNAL = "WS_CALL_SIGNAL",
  ROOM_LIST_CHANGED = "WS_ROOM_LIST_CHANGED",
  USER_UPDATED = "WS_USER_UPDATED",
}
